import momentModule from 'moment-timezone';
import {extendMoment} from 'moment-range';

momentModule.tz.setDefault('Etc/UTC');

// @ts-ignore
export const moment = extendMoment(momentModule);
